function loadSearchResults() {
  jQuery.ajax({
    type: "get",
    url: Ajax.ajaxurl,
    data: {
      action: "load_search_results",
      query: jQuery("#searchForm").serializeArray(),
    },
    beforeSend: function () {
      jQuery(".post-results").hide();
      jQuery(".loader").removeClass("hide");
      window.history.pushState(
        {},
        "Search",
        window.location.href.split("?")[0] +
          "?" +
          jQuery("#searchForm").serialize()
      );
    },
    success: function (response) {
      jQuery(".post-results").html(response);
    },
    complete: function () {
      jQuery(".loader").addClass("hide");
      jQuery(".post-results").show();
    },
  });
}

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars()
{
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for(var i = 0; i < hashes.length; i++)
  {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    vars[hash[0]] = hash[1];
  }
  return vars;
}


jQuery(document).ready(function () {
  jQuery("#reset-search").on("click", function (e) {
    e.stopPropagation();
    window.location = jQuery(e.currentTarget).attr("data");
    return false;
  });
  jQuery(".toggle-filter-children").on("click", function (e) {
    e.preventDefault();
  });
  jQuery(".govuk-date-input__input")
    .closest(".govuk-date-input")
    .removeClass("selected");
  jQuery(".govuk-date-input__input")
    .filter(function () {
      return this.value !== "";
    })
    .closest(".govuk-date-input")
    .addClass("selected");
  if (!jQuery(".indeterminate").is(":checked")) {
    jQuery(".indeterminate").prop("indeterminate", true);
    jQuery(".indeterminate")
      .closest(".gem-c-checkboxes__list-item")
      .addClass("selected");
  }
  jQuery("#searchForm input[type=checkbox]").on("change", function (e) {
    var target = jQuery(e.currentTarget);
    if (target.hasClass("child-element")) {
      var childTerms = target.closest(".child-terms");
      var parentTerm = childTerms.prev().find("input");
      if (
        childTerms.find("input:checked").length > 0 &&
        !parentTerm.is(":checked")
      ) {
        parentTerm.prop("indeterminate", true);
      } else {
        parentTerm.prop("indeterminate", false);
      }
    }
    if (target.hasClass("parent-element")) {
      target.prop("indeterminate", false);
      if (!target.is(":checked")) {
        var container = target.closest(".parent-element-li");
        var childTerms = container.next();
        if (childTerms.find("input:checked").length > 0) {
          childTerms.prev().find("input").prop("indeterminate", true);
        } else {
          childTerms.prev().find("input").prop("indeterminate", false);
        }
      }
    }
    loadSearchResults();
  });

  jQuery("#posts_per_page").on("change", function (e) {
    loadSearchResults();
  });

  jQuery("#searchForm").on("submit", function (e) {
    e.preventDefault();
    loadSearchResults();
    jQuery("#searchResults .no-of-results").focus();
  });
});
